/* eslint-disable */
class IconCardContainer extends HTMLElement {
  constructor() {
    super()
    this.root = this.attachShadow({ mode: 'open' })
    this.root.innerHTML = `
    <style>

   .slot-style{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 32px;
      justify-content: space-between;
      /*width: 100%;*/
      height: 100%;
    } 
    .slot-style ::slotted(*) {
      flex-grow: 1;
    }
    </style>
    <div >
    <slot class="slot-style"></slot>
    </div>`
  }
}

customElements.define('icon-card-container', IconCardContainer)

class IconCard extends HTMLElement {
  constructor() {
    super()
    this.root = this.attachShadow({ mode: 'open' })
    this.root.appendChild(IconCard.__style.content.cloneNode(true))
    this.root.appendChild(IconCard.__template.content.cloneNode(true))
  }

  getSVGMap() {
    return {
      CHAT: IconCard.chatSVG,
      PHONE: IconCard.phoneSVG,
      EMAIL: IconCard.emailSVG,
    }
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    if (oldValue === newValue) return

    // Setup the ContactDetailsIdBottomLine href
    if (attr === 'href') {
      let contactDetailsIdBottomLine = this.root.querySelector('#contactDetailsBottomLine')
      contactDetailsIdBottomLine.href = newValue
      return
    }

    // Setup the ContactDetails href
    if (attr === 'hrefemail') {
      let contactDetails = this.root.querySelector('#contactDetails')
      contactDetails.href = newValue
      return
    }

    // Get the image based on the card type
    if (attr === 'cardtype') {
      let imageSVG = this.root.querySelector('#imageSVG')
      const svgType = newValue.toUpperCase()
      if (svgType in this.getSVGMap()) {
        imageSVG.innerHTML = this.getSVGMap()[svgType]
      } else {
        imageSVG.innerHTML = IconCard.infoSVG
      }
      return
    }
    let component = this.root.querySelector(`[id="${attr}" i]`)
    component.innerHTML = newValue
  }

  static get observedAttributes() {
    return [
      'cardtitle',
      'contactdetails',
      'contactdetailsbottomline',
      'extradescription',
      'supportingtext',
      'href',
      'hrefemail',
      'cardtype',
    ]
  }
}

IconCard.infoSVG = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8.93 6.588L7.93 11.293C7.86 11.633 7.959 11.826 8.234 11.826C8.428 11.826 8.721 11.756 8.92 11.58L8.832 11.996C8.545 12.342 7.912 12.594 7.367 12.594C6.664 12.594 6.365 12.172 6.559 11.275L7.297 7.807C7.361 7.514 7.303 7.408 7.01 7.337L6.559 7.256L6.641 6.875L8.931 6.588H8.93ZM8 5.5C7.73478 5.5 7.48043 5.39464 7.29289 5.20711C7.10536 5.01957 7 4.76522 7 4.5C7 4.23478 7.10536 3.98043 7.29289 3.79289C7.48043 3.60536 7.73478 3.5 8 3.5C8.26522 3.5 8.51957 3.60536 8.70711 3.79289C8.89464 3.98043 9 4.23478 9 4.5C9 4.76522 8.89464 5.01957 8.70711 5.20711C8.51957 5.39464 8.26522 5.5 8 5.5Z" fill="#001996"/>
</svg>`

IconCard.emailSVG = `<svg viewBox="0 0 74 69" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.63944 58.264L29.415 38.2429L35.8078 43.8546C36.1572 44.1629 36.5683 44.3068 37 44.3068C37.4317 44.3068 37.8428 44.1629 38.1922 43.8546L44.585 38.2429L67.3606 58.264H6.63944ZM3.63833 15.5907L26.6606 35.8379L3.63833 56.0852V15.5907V15.5907ZM72.1911 9.75293H52.725C52.9922 10.9246 53.1567 12.1374 53.1567 13.3913H70.3617V56.0852L47.3394 35.8379L64.6678 20.6063C65.4283 19.9485 65.49 18.7974 64.8322 18.0368C64.1744 17.2763 63.0233 17.2146 62.2628 17.8724L43.4956 34.3785C43.4956 34.3785 43.4956 34.3785 43.475 34.399L37 40.0724L6.63944 13.3913H20.8433C20.8433 12.1374 21.0078 10.9246 21.275 9.75293H1.80889C0.822222 9.75293 0 10.5546 0 11.5618V60.0935C0 60.1346 0 60.1552 0.0205556 60.1963C0.0205556 60.2579 0.0205556 60.3196 0.0411111 60.3813C0.0411111 60.4429 0.0616667 60.484 0.0822222 60.5457C0.102778 60.6074 0.102778 60.669 0.143889 60.7102C0.143889 60.7924 0.164444 60.8335 0.205556 60.8952C0.226111 60.9363 0.246667 60.9979 0.287778 61.039C0.328889 61.1007 0.37 61.1624 0.411111 61.2035C0.431667 61.224 0.452222 61.2652 0.472778 61.2857C0.472778 61.3063 0.493333 61.3063 0.513889 61.3268C0.575556 61.3885 0.637222 61.4296 0.698889 61.4913C0.74 61.5118 0.760556 61.5529 0.801667 61.5735C0.863333 61.6146 0.925 61.6557 1.00722 61.6968C1.04833 61.7174 1.08944 61.7379 1.13056 61.7585C1.21278 61.7996 1.31556 61.8202 1.41833 61.8613C1.43889 61.8613 1.45944 61.8818 1.48 61.8818C1.60333 61.9024 1.72667 61.9229 1.85 61.9229H72.2117C72.335 61.9229 72.4583 61.9229 72.5817 61.8818C72.6022 61.8818 72.6228 61.8613 72.6433 61.8613C72.7461 61.8407 72.8283 61.8202 72.9311 61.7585C72.9722 61.7379 73.0133 61.7174 73.0544 61.6968C73.1161 61.6557 73.1983 61.6146 73.26 61.5735C73.3011 61.5529 73.3422 61.5118 73.3628 61.4913C73.4244 61.4296 73.4861 61.3885 73.5478 61.3268C73.5683 61.3268 73.5683 61.3063 73.5889 61.2857C73.6094 61.2652 73.63 61.224 73.6506 61.2035C73.6917 61.1624 73.7328 61.1007 73.7739 61.039C73.7944 60.9979 73.8356 60.9363 73.8561 60.8952C73.8767 60.8335 73.9178 60.7924 73.9383 60.7307C73.9589 60.669 73.9794 60.6279 74 60.5663C74.0206 60.5046 74.0206 60.4635 74.0411 60.4018C74.0617 60.3402 74.0617 60.2785 74.0617 60.2168C74.0617 60.1757 74.0822 60.1346 74.0822 60.114V11.5618C74 10.5546 73.1778 9.75293 72.1911 9.75293Z" fill="#001996"/>
<path d="M36.3218 18.304C37.2057 18.304 37.9662 17.8724 38.6034 17.009C39.2407 16.1457 39.5696 15.159 39.5696 14.049C39.5696 13.1446 39.3023 12.4457 38.7884 11.8907C38.2746 11.3768 37.6784 11.1096 37.0001 11.1096C36.2396 11.1096 35.5818 11.459 35.0679 12.1785C34.5334 12.8979 34.2868 13.8435 34.2868 14.9946C34.2868 15.9402 34.4718 16.7213 34.8418 17.3585C35.2323 17.9957 35.7257 18.304 36.3218 18.304ZM41.5223 7.71793C42.6734 7.71793 43.5573 8.72515 43.434 9.87626L42.6529 16.3102C42.5912 16.9063 42.5501 17.4202 42.5501 17.8518C42.5501 18.3863 42.7968 18.6535 43.2901 18.6535C44.2151 18.6535 45.099 18.0779 45.9623 16.9063C46.8257 15.7552 47.2368 14.2752 47.2368 12.5279C47.2368 9.97904 46.3118 7.86182 44.4412 6.17626C42.5707 4.49071 40.289 3.64793 37.5757 3.64793C34.6362 3.64793 32.1696 4.67571 30.1551 6.71071C28.2229 8.68404 27.2157 11.1096 27.1334 14.0079C27.0923 15.4674 27.3596 16.9063 27.8734 18.2629C29.5796 22.6824 32.9301 24.9024 37.9251 24.9024C40.0834 24.9024 42.3034 24.409 44.5851 23.4429C45.4484 23.0729 46.4557 23.484 46.8051 24.3474C47.1546 25.2107 46.7434 26.1768 45.8801 26.5468C43.2901 27.6568 40.6384 28.2118 37.9457 28.2118C33.4645 28.2118 29.9084 26.8552 27.2568 24.1213C24.6051 21.3874 23.2896 18.1396 23.2896 14.3574C23.2896 10.4107 24.6873 7.12182 27.4623 4.47015C30.2373 1.81849 33.6084 0.50293 37.5346 0.50293C41.2962 0.50293 44.4207 1.65404 46.949 3.99737C49.4773 6.32015 50.7312 9.13626 50.7312 12.4457C50.7312 15.0563 49.9501 17.2763 48.4084 19.1263C46.8668 20.9763 45.0373 21.9013 42.8996 21.9013C41.4607 21.9013 40.3712 21.3463 39.6312 20.2363C38.6446 21.4079 37.4729 21.9835 36.0751 21.9835C34.5334 21.9835 33.1973 21.3257 32.1079 20.0307C30.9979 18.7152 30.4634 17.009 30.4634 14.8713C30.4634 12.6924 31.0801 10.904 32.3134 9.52682C33.5673 8.12904 35.0473 7.45071 36.7945 7.45071C37.9046 7.45071 38.9118 7.84126 39.8162 8.58126L40.0423 7.73849H41.5223V7.71793Z" fill="#001996"/>
</svg>`

IconCard.chatSVG = `<svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_1124_10813)">
<circle cx="25.5" cy="25.5" r="23.5" fill="#001996"/>
<circle cx="25.5" cy="25.5" r="23" stroke="#1F408F"/>
</g>
<g filter="url(#filter1_d_1124_10813)">
<path d="M34.8254 14.6826H16.9207C15.277 14.6826 13.9365 16.0231 13.9365 17.6248V31.0114C13.9365 32.655 15.277 33.9536 16.9207 33.9536H21.3968V37.8283C21.3968 38.2829 21.9214 38.5486 22.2883 38.2805L28.1121 33.9116H34.8263C36.4699 33.9116 37.8105 32.5711 37.8105 30.9694V17.6248C37.8095 16.0231 36.5086 14.6826 34.8254 14.6826ZM26.288 28.1112H21.0658C20.4503 28.1112 19.9467 27.6123 19.9467 26.9921C19.9467 26.372 20.4503 25.8731 21.0658 25.8731H26.288C26.9081 25.8731 27.4071 26.3767 27.4071 26.9921C27.4071 27.6076 26.9081 28.1112 26.288 28.1112ZM30.7642 23.635H21.0658C20.4503 23.635 19.9467 23.1361 19.9467 22.516C19.9467 21.8958 20.4503 21.3969 21.0658 21.3969H30.7642C31.3843 21.3969 31.8832 21.9005 31.8832 22.516C31.8832 23.1314 31.3843 23.635 30.7642 23.635Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_1124_10813" x="0" y="0" width="55" height="55" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="2" dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1124_10813"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1124_10813" result="shape"/>
</filter>
<filter id="filter1_d_1124_10813" x="9.93652" y="14.6826" width="31.874" height="31.7051" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1124_10813"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1124_10813" result="shape"/>
</filter>
</defs>
</svg>
`
IconCard.phoneSVG = `<svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.9399 28.9543L37.2899 38.3043L39.4044 36.1898L29.1744 27.7198L27.9399 28.9543ZM37.2899 40.932C37.0088 40.932 36.7277 40.822 36.5199 40.6143L25.6299 29.7243C25.2021 29.2965 25.2021 28.612 25.6299 28.1843L28.331 25.4831C28.7221 25.0798 29.3699 25.0554 29.7977 25.4098L41.7144 35.2731C41.9466 35.4687 42.0933 35.7498 42.1055 36.0554C42.1177 36.3609 42.0077 36.6665 41.7877 36.8743L38.0599 40.602C37.8521 40.8343 37.571 40.932 37.2899 40.932Z" fill="#001996"/>
<path d="M28.2578 43.4258C23.9067 43.4258 17.5756 41.5436 9.88783 33.8924C3.33672 27.378 5.24786e-05 21.3647 5.24786e-05 16.0236C-0.0121697 11.8313 2.1145 9.668 2.21227 9.57022C2.40783 9.36244 2.68894 9.25244 2.98228 9.25244C3.27561 9.25244 3.5445 9.37466 3.75227 9.57022L12.4545 18.2847C12.7112 18.5413 12.8334 18.9202 12.7478 19.2747C12.2345 21.7436 14.8134 25.8869 16.3534 27.4147C17.8445 28.9058 22.0734 31.5213 24.5056 31.0202C24.8723 30.9469 25.2389 31.0569 25.4956 31.3136L34.2101 40.028C34.6378 40.4558 34.6378 41.1402 34.2101 41.568C33.7823 41.9958 33.0978 41.9958 32.6701 41.568L24.3467 33.2447C20.7289 33.538 16.0967 30.2258 14.8256 28.9669C13.2734 27.4269 10.2178 23.0269 10.5356 19.4458L3.1045 12.0147C1.80894 14.3124 -0.0366139 20.9491 11.4156 32.3402C19.5801 40.4558 25.8745 41.6047 29.7123 41.1524C30.3112 41.0791 30.8489 41.5069 30.9223 42.1058C30.9956 42.7047 30.5678 43.2424 29.9689 43.3158C29.4434 43.3891 28.8689 43.4258 28.2578 43.4258Z" fill="#001996"/>
<path d="M5.47545 6.47761L14.8254 15.8276L16.0599 14.5932L7.57767 4.36316L5.47545 6.47761ZM14.8254 18.4676C14.5321 18.4676 14.2632 18.3454 14.0554 18.1498L3.15323 7.24761C2.95767 7.05205 2.83545 6.77094 2.83545 6.47761C2.83545 6.18427 2.94545 5.91538 3.15323 5.70761L6.881 1.97983C7.10101 1.75983 7.40656 1.64983 7.69989 1.66205C8.00545 1.67427 8.28656 1.82094 8.48212 2.05316L18.3454 13.9698C18.6999 14.3976 18.6754 15.0332 18.2721 15.4365L15.571 18.1376C15.3877 18.3454 15.1066 18.4676 14.8254 18.4676Z" fill="#001996"/>
<path d="M38.219 22.8434C37.6201 22.8434 37.1312 22.3545 37.1312 21.7556C37.1312 13.3223 30.2745 6.46559 21.8412 6.46559C21.2423 6.46559 20.7534 5.97671 20.7534 5.37782C20.7534 4.77893 21.2423 4.29004 21.8412 4.29004C31.4723 4.29004 39.3068 12.1245 39.3068 21.7556C39.3068 22.3545 38.8179 22.8434 38.219 22.8434Z" fill="#00A9CE"/>
<path d="M34.0267 22.8435C33.4279 22.8435 32.939 22.3546 32.939 21.7558C32.939 15.6324 27.9645 10.658 21.8412 10.658C21.2423 10.658 20.7534 10.1691 20.7534 9.5702C20.7534 8.97131 21.2423 8.48242 21.8412 8.48242C29.1623 8.48242 35.1267 14.4346 35.1267 21.768C35.1145 22.3546 34.6379 22.8435 34.0267 22.8435Z" fill="#00A9CE"/>
<path d="M42.509 22.8433C41.9101 22.8433 41.4212 22.3544 41.4212 21.7556C41.4212 10.9633 32.6334 2.17556 21.8412 2.17556C21.2423 2.17556 20.7534 1.68667 20.7534 1.08778C20.7534 0.488889 21.2423 0 21.8412 0C33.8312 0 43.5968 9.76555 43.5968 21.7556C43.5968 22.3544 43.1079 22.8433 42.509 22.8433Z" fill="#00A9CE"/>
</svg>`

Object.defineProperties(IconCard, {
  __style: {
    configurable: false,
    enumerable: false,
    writable: false,
    value: document.createElement('template'),
  },
  __template: {
    configurable: false,
    enumerable: false,
    writable: false,
    value: document.createElement('template'),
  },
})
IconCard.__style.innerHTML = `
<style>
.icon-card-style {
    width: 321px;
   /* height: auto;*/
    padding: 5px;
    justify-content: start;
    display: flex;
    flex-grow: 1;
}

.img {
    width: 44px;
    height: 44px;
    float: left;
    padding-right: 15px;
    margin-top: 14px;
    display: flex;
}

.leftTextAlign {
    justify-content: center;
}

a {
    font-size: 16px;
    color: #002090;
    font-family: "Open Sans", sans-serif;
    margin-bottom: 10px;
    margin-top: 10px;
}

p {
    font-size: 16px;
    font-family: "Open Sans", sans-serif;
    margin-bottom: 10px;
    margin-top: 10px;
}

.p-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
}

.p-extraDescription {
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    margin-bottom: 10px;
    margin-top: 10px;
}


@media screen and (min-width: 690px) and (max-width: 767px) {
    .icon-card-style {
        width: 380px;
    }
} 

@media screen and (min-width: 768px) {
    .icon-card-style {
        width: 321px;
    }
}

@media screen and (min-width: 950px) {
    .icon-card-style {
        width: 422px;
    }
}

@media screen and (min-width: 1200px) {
    .icon-card-style {
        width: 330px !important;
    }
}

</style>
`
IconCard.__template.innerHTML = `
<div class="icon-card-style">
<div class="img" id="imageSVG"></div>
<div class="leftTextAlign">
  <p class="p-title" id="cardTitle"></p>
  <a id="contactDetails"></a>
  <p class="p-extraDescription" id="extraDescription"></p>
  <p id="supportingText"></p>
  <a id="contactDetailsBottomLine"></a>
  
</div>
</div>
`

customElements.define('icon-card', IconCard)
